import notifyMixin from '@/mixin/notify'
import { mapGetters } from 'vuex'
export default {
  mixins: [notifyMixin],
  computed: {
    ...mapGetters({
      userinfo: 'userinfo',
    }),
    isLogin () {
      console.log('userinfo', this.userinfo)
      return (this.userinfo) ? this.userinfo.isLogin : false
    },
    userinfo () {
      return (this.userinfo) ? this.userinfo : false
    }
  },
  methods: {
    isPhone (val) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(val)) {
        return false
      } else {
        return true
      }
    },
    formatDate (val) {
      var date = new Date(val)
      var year = date.getFullYear()
      var month = date.getMonth()+1
      var day = date.getDate()
      return year + '年' + month + '月' + day + '日'
    },
    isRealNum (val) {
      if (val === "" || val ==null) {
          return false
      }
     if (!isNaN(val)) {
        return true
      } else {
        return false
      }
    }
  }
}